import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED, serverTimestamp } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDJQZOV4GYF0qqZOQgCl1yfI4oNEVU_Adc",
  authDomain: "test-c38ce.firebaseapp.com",
  projectId: "test-c38ce",
  storageBucket: "test-c38ce.appspot.com",
  messagingSenderId: "1234567890",
  appId: "1:1234567890:web:abcdef1234567890",
  databaseURL: "https://test-c38ce-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app);

// Use emulator in development
if (import.meta.env.DEV) {
  try {
    // Connect to Firebase Functions emulator
    connectFunctionsEmulator(functions, "localhost", 5001);
    console.log('Connected to Firebase Functions emulator');
  } catch (error) {
    console.error('Failed to connect to Firebase Functions emulator:', error);
    console.warn('Continuing without emulator connection');
  }
}

// Enable offline persistence only in browser environment
if (typeof window !== 'undefined') {
  // Use a try-catch block to handle any errors with persistence
  try {
    enableIndexedDbPersistence(db, {
      cacheSizeBytes: CACHE_SIZE_UNLIMITED
    })
      .then(() => {
        console.log('Firestore persistence enabled successfully');
      })
      .catch((error) => {
        if (error.code === 'failed-precondition') {
          // Multiple tabs open, persistence can only be enabled in one tab at a time
          console.warn('Persistence failed: Multiple tabs open');
        } else if (error.code === 'unimplemented') {
          // The current browser doesn't support persistence
          console.warn('Persistence not supported by browser');
        } else {
          console.error('Error enabling offline persistence:', error);
        }
      });
  } catch (error) {
    console.error('Exception when setting up Firestore persistence:', error);
  }
}

// Export a function to get server timestamp
export const getServerTimestamp = () => serverTimestamp();

export { db, functions };